/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
var REMINDER = ['pay_by_link', 'pay_later_1st_reminder', 'pay_later_2nd_reminder', 'pay_later_3rd_reminder'];
var TRANSACTION = ['sale', 'sale3d', 'init_recurring_sale', 'init_recurring_sale3d', 'recurring_sale', 'capture', 'refund', 'incremental_authorize', 'partial_reversal', 'authorize', 'authorize3d', 'void'];
var WITH_DEFAULT_TEMPLATES = ['fraud', 'final_transaction_status'];
var WITH_CUSTOM_TEMPLATES = [].concat(REMINDER, TRANSACTION);
var WITHOUT_RECIPIENTS = [].concat(REMINDER, TRANSACTION);
var REMINDER_VARS = ['{{payment.first_name}}', '{{payment.last_name}}', '{{payment.address}}', '{{payment.zip_code}}', '{{payment.state}}', '{{payment.country}}', '{{payment.link}}', '{{payment.amount_with_currency}}', '{{payment.transaction_types}}'];
var TRANSACTION_VARS = ['{{payment.amount_with_currency}}', '{{payment.timestamp}}', '{{payment.transaction_type}}', '{{payment.transaction_id}}', '{{payment.usage}}', '{{payment.card_brand}}', '{{payment.card_holder}}', '{{payment.card_number}}', '{{payment.has_billing_address}}', '{{payment.billing_address}}', '{{payment.billing_city}}', '{{payment.billing_country}}', '{{payment.billing_first_name}}', '{{payment.billing_last_name}}', '{{payment.billing_state}}', '{{payment.billing_zip_code}}'];
var EmailConfiguration = {
  WITH_DEFAULT_TEMPLATES: WITH_DEFAULT_TEMPLATES,
  WITH_CUSTOM_TEMPLATES: WITH_CUSTOM_TEMPLATES,
  WITHOUT_RECIPIENTS: WITHOUT_RECIPIENTS
};

var getVariablesFor = function getVariablesFor(configurationType) {
  switch (true) {
    case TRANSACTION.includes(configurationType):
      return TRANSACTION_VARS;

    case REMINDER.includes(configurationType):
      return REMINDER_VARS;

    default:
      return [];
  }
};

export { getVariablesFor, EmailConfiguration };